<template>
    <FeedBack
        v-if="conf && inited && fbVisible && helpState"
        ref="feedbackRef"
        :env="conf.env"
        :lang="conf.lang"
        :userInfo="conf.userInfo"
        :componentBottom="conf.componentBottom"
        :intimeevaluateUserInfo="conf.intimeevaluateUserInfo"
        :intimeevaluateTempleteInfo="conf.intimeevaluateTempleteInfo"
        :tabs="conf.tabs"
        :whetherTheCoexistence="conf.whetherTheCoexistence"
        :configInfo="conf.configInfo" />
</template>

<script>
import FeedBack from 'itsm-feedback-v2';
import { mapState, mapGetters } from 'vuex';
import config from '@/config/user.env';
import { createTmsConf } from './tmsConf.js';
import { createSrmConf } from './srmConf.js';
import { createBmsConf } from './bmsConf.js';
import { createCciConf } from './cciConf.js';
// import './help';
// import { getItsmLogin } from '../../api/common';
export default {
    data() {
        return {
            currentSystem: '',
            token: '',
            inited: false,
            conf: null,
            helpState: true
        };
    },
    components: { FeedBack },
    computed: {
        ...mapState(['itsmToken', 'contactsMobile']),
        ...mapGetters(['user']),
        fbVisible() {
            // 非 '/outPage/', '/app-cci/' 前缀的页面才显示运营工具
            return !['/outPage/', '/app-cci/'].some(item => this.$route.path.indexOf(item) >= 0)
        }
    },
    watch: {
        '$route': {
            handler(route) {
                if (this.currentSystem === parseSystemName(route) || !this.user || !this.inited) { return; }
                // 兼容智能客服不能更新的问题
                this.inited = false;
                this.$nextTick(() => {
                    // this.updateConf(this.buildConf(route));
                    this.conf = this.buildConf(route);
                    this.inited = true;
                });
            },
            immediate: true
        },
        itsmToken: {
            handler(val) {
                if (val) {
                    this.conf = this.buildConf();
                    this.inited = true;
                }
            },
            immediate: true
        },
        contactsMobile: {
            handler(val) {
                if (val) {
                    this.conf = this.buildConf();
                    // this.inited = true;
                }
            },
            immediate: true
        }
    },
    methods: {
        // 抓取页面url
        initCommonFieldList() {
            // this.conf.userInfo.commonFieldList.push(
            //     { name: '页面链接', value: window.location.href });
        },
        buildConf(route) {
            const user = this.user || {};
            const system = this.currentSystem = parseSystemName(route || this.$route);
            const createConfObj = {
                srm: createSrmConf,
                tms: createTmsConf,
                bms: createBmsConf,
                cci: createCciConf,
            }
            return createConfObj[system] ? createConfObj[system].bind(this)(config, user) : createSrmConf.bind(this)(config, user);
        }
        // updateConf(conf) {
        //     this.conf = conf;

        //     const currentResource = this.visitedViews.find(item => item.path === this.$route.path);
        //     if (currentResource) {
        //         this.conf.helpInfo.relateId = String(currentResource.resourceCode || '');
        //     }
        // },
        // getToken() {
        //     getItsmLogin({
        //         user: this.user.userCode,
        //         authSource: '4a'
        //     }).then(res => {
        //         const { data } = res;
        //         if (res && data && data.status && data.statusCode === '00') {
        //             this.token = res.data.tokenId;
        //         }
        //     }).finally(() => {
        //         // 兼容接口错误时，才用内网模式 token为空
        //         this.updateConf(this.buildConf());
        //         this.inited = true;
        //     });
        // }
    },
    mounted() {
        setTimeout(() => {
            this.helpState = true;
        }, 3000);
    }
};
// 根据路配置的system属性来判断系统归属
function parseSystemName(route) {
    return (route && route.meta && route.meta.system) || 'srm'; // 'srm' | 'tms' | 'bms' | 'cci'
}
</script>

<style lang="less">
</style>
